export const AI_ASSISTANT_BENEFITS = [
  "Save time & augment client care",
  "Prebuilt clinical templates",
  "Real-time telehealth transcription",
  "Record in-person appointments",
  "Instant session summaries",
  "Auto-generated clinical notes",
  "In-depth post-session analytics",
];

export const CORE_BENEFITS = [
  "HIPAA-compliant EHR",
  "Beautiful design",
  "Seamless  client onboarding",
  "Unlimited scheduling",
  "Automated billing",
  // "Low payment processing fees",
  "Guaranteed payments",
  "Reliable telehealth",
  "Secure client messaging",
  "Professional directory listing",
];

export const COMPLETE_BENEFITS = [
  "100% done-for-you client chart imports",
  "Free template conversions",
  "Unlimited storage",
  "Lowest payment processing fees",
  "Calendar sync",
  "Business analytics",
  "Professional networking",
  "Early access features",
  "24/7 live  support",
  "Complete AI Toolkit",
];

export const AI_ONLY_BENEFITS = [
  "Real-time telehealth transcription",
  "Instant session summaries Auto-generated clinical notes",
  "In-depth post-session analytics",
  "Priority access to new AI features",
];

export const ENTERPRISE_BENEFITS = [
  "Enterprise-level security",
  "Customization to fit your unique needs",
  "Integration with your existing systems",
  "Seamless performance, regardless of your team's size",
  "Enhanced business analytics",
  "Custom AI solutions",
  "Priority support & training, including on-site assistance",
];

export const ENABLED_PLAN_TYPES: PlanType[] = [
  "complete",
  "core",
  "enterprise",
  "core-with-ai",
];

export const PLAN_DISPLAY_NAMES: { [planType in PlanType]: string } = {
  complete: "Complete",
  core: "Core",
  "core-with-ai": "Core with AI Toolkit",
  enterprise: "Enterprise",
  "ai-only": "AI Assistant",
};

export const PLAN_PRICE_STRINGS: { [planType in PlanType]: string } = {
  complete: "$28.99",
  core: "$19.99",
  "core-with-ai": "$29.97",
  enterprise: "Custom",
  "ai-only": "$9.99",
};

export const TRANSITIONING_TO_ORCHID: FeatureRows = [
  {
    feature: "Free Onboarding Session",
    featureTooltip:
      "Receive a complimentary onboarding session, personalized to your clinical needs.",
    core: "available",
    complete: "available",
    enterprise: "available",
    "ai-only": "available",
  },
  {
    feature: "Additional Free Onboarding Sessions",
    featureTooltip:
      "Request additional support sessions based on availability.",
    core: "not-available",
    complete: "available",
    enterprise: "available",
    "ai-only": "not-available",
  },
  {
    feature: "Done-for-You Patient Chart Imports",
    featureTooltip:
      "48-hour turnaround to switch from another platform and transfer all materials.",
    core: "not-available",
    complete: "available",
    enterprise: "available",
    "ai-only": "not-available",
  },
  {
    feature: "24/7 Live Customer Support",
    featureTooltip: "Connect via chat, email, phone, or video.",
    core: "not-available",
    complete: "available",
    enterprise: "available",
    "ai-only": "not-available",
  },
];

// TODO: fix checks
export const SCHEDULING_FEATURES: FeatureRows = [
  {
    feature: "Unlimited Appointment Requests",
    featureTooltip: "Allow clients to request appointments online.",
    core: "available",
    complete: "available",
    enterprise: "available",
    "ai-only": "available",
  },
  {
    feature: "Telehealth",
    featureTooltip:
      "Remain HIPAA-compliant with screen-sharing and virtual background capabilities.",
    core: "not-available",
    complete: "available",
    enterprise: "available",
    "ai-only": "available",
  },
  {
    feature: "Calendar Sync",
    featureTooltip:
      "Connect your Orchid calendar with Google Calendar, Outlook, or iCal.",
    core: "not-available",
    complete: "available",
    enterprise: "available",
    "ai-only": "available",
  },
  {
    feature: "Advanced Calendar Filters",
    featureTooltip:
      "Apply filters based on appointment types, location, note status, and more.",
    core: "not-available",
    complete: "available",
    enterprise: "available",
    "ai-only": "not-available",
  },
  {
    feature: "Automated Appointment Reminders",
    featureTooltip: "Send reminders via email, text, or phone.",
    core: "available",
    complete: "available",
    enterprise: "available",
    "ai-only": "available",
  },
  {
    feature: "Confirm/Cancel via Text",
    featureTooltip:
      "Allow clients to confirm or cancel upcoming appointments via text message.",
    core: "not-available",
    complete: "available",
    enterprise: "available",
    "ai-only": "available",
  },
  {
    feature: "Group Therapy",
    featureTooltip: "Create group therapy sessions.",
    core: "not-available",
    complete: "available",
    enterprise: "available",
    "ai-only": "not-available",
  },
  {
    feature: "Client Waitlist",
    featureTooltip: "Add clients, track appointment requests, and more.",
    core: "not-available",
    complete: "available",
    enterprise: "available",
    "ai-only": "not-available",
  },
];

export const AI_FEATURES: FeatureRows = [
  {
    feature: "Unlimited Auto-Generated Clinical Notes",
    featureTooltip:
      "Free yourself from manual documentation with effortlessly crafted clinical notes from each session, enabling more focused patient interaction.",
    core: "add-on",
    complete: "available",
    enterprise: "available",
    "ai-only": "available",
  },
  {
    feature: "AI-Training Based on Prior Notes",
    featureTooltip:
      "Enhance AI accuracy that learns from your previous notes, continuously improving and personalizing suggestions for a smoother workflow.",
    core: "add-on",
    complete: "available",
    enterprise: "available",
    "ai-only": "available",
  },
  {
    feature: "CPT Code Suggestions",
    featureTooltip:
      "Reduce billing errors and ensure optimum reimbursement with intelligent CPT code suggestions tailored to each case.",
    core: "add-on",
    complete: "available",
    enterprise: "available",
    "ai-only": "available",
  },
  {
    feature: "Diagnoses Suggestions",
    featureTooltip:
      "Receive insightful diagnostic suggestions, aiding in accurate and timely patient assessment.",
    core: "add-on",
    complete: "available",
    enterprise: "available",
    "ai-only": "available",
  },
  {
    feature: "Auto-Generated Treatment Plans",
    featureTooltip:
      "Get automatic treatment plan generation, letting you deliver personalized care with greater efficiency.",
    core: "add-on",
    complete: "available",
    enterprise: "available",
    "ai-only": "available",
  },
  {
    feature: "Supervision Review Assistance",
    featureTooltip:
      "Elevate your supervisory role using AI-assisted review analysis of any trainee's work.",
    core: "add-on",
    complete: "available",
    enterprise: "available",
    "ai-only": "available",
  },
  {
    feature: "Live Telehealth Auto-Transcription",
    featureTooltip:
      "Access a live transcription of your appointment to help you further uncover session insights.",
    core: "add-on",
    complete: "available",
    enterprise: "available",
    "ai-only": "available",
  },
  {
    feature: "Upload Access for Session Recordings",
    featureTooltip:
      "Get a summary of an appointment's speech cadence between the client and the clinician, talking-time per speaker,  and any moments of silence.",
    core: "add-on",
    complete: "available",
    enterprise: "available",
    "ai-only": "available",
  },
  {
    feature: "Auto-Summarized Sessions",
    featureTooltip:
      "Get a summary of an appointment, including topics discussed and important places and people mentioned.",
    core: "add-on",
    complete: "available",
    enterprise: "available",
    "ai-only": "available",
  },
  {
    feature: "Auto-Generated Session Analytics",
    featureTooltip:
      "Get insights into the speech cadence between the client and the clinician, talking-time per speaker,  and any moments of silence.",
    core: "add-on",
    complete: "available",
    enterprise: "available",
    "ai-only": "available",
  },
  {
    feature: "Advanced Session Analytics",
    featureTooltip:
      "Get valuable clinical insights such as sentiment analysis.",
    core: "not-available",
    complete: "not-available",
    enterprise: "available",
    "ai-only": "available",
  },
];

export const DOCUMENTATION_FEATURES: FeatureRows = [
  {
    feature: "Unlimited Patient Charts",
    featureTooltip:
      "Create and maintain charts with no limits on your caseload.",
    core: "available",
    complete: "available",
    enterprise: "available",
    "ai-only": "available",
  },
  {
    feature: "Comprehensive Templates Library",
    featureTooltip:
      "Choose from dozens of pre-built note and assessment templates.",
    core: "available",
    complete: "available",
    enterprise: "available",
    "ai-only": "available",
  },
  {
    feature: "Customizable Notes & Assessments",
    featureTooltip:
      "Create custom note templates and assessments with our fully customizable  template builder.",
    core: "available",
    complete: "available",
    enterprise: "available",
    "ai-only": "available",
  },
  {
    feature: "Good Faith Estimates",
    featureTooltip: "Generate Good Faith Estimates for your clients.",
    core: "available",
    complete: "available",
    enterprise: "available",
    "ai-only": "available",
  },
  {
    feature: "Progress Notes",
    featureTooltip: "Create, sign, and submit notes to each client's records.",
    core: "available",
    complete: "available",
    enterprise: "available",
    "ai-only": "available",
  },
  {
    feature: "Psychotherapy Notes",
    featureTooltip:
      "Create notes that are kept separate from the client's medical record.",
    core: "available",
    complete: "available",
    enterprise: "available",
    "ai-only": "available",
  },
  {
    feature: "Loadable Previous Notes",
    featureTooltip:
      "Save time on clinical documentation by loading notes from past appointments.",
    core: "not-available",
    complete: "available",
    enterprise: "available",
    "ai-only": "available",
  },
  {
    feature: "Administrative Notes",
    featureTooltip: "Add a non-clinical, sticky note to a client's chart.",
    core: "not-available",
    complete: "not-available",
    enterprise: "not-available",
    "ai-only": "available",
  },
  {
    feature: "Diagnosis & Treatment Plans",
    featureTooltip: "Create and save diagnosis and treatment plans.",
    core: "available",
    complete: "available",
    enterprise: "available",
    "ai-only": "available",
  },
  {
    feature: "Note Addendums",
    featureTooltip: "Add an addendum to a note after it is signed & submitted.",
    core: "available",
    complete: "available",
    enterprise: "available",
    "ai-only": "available",
  },
  {
    feature: "Note Attachments",
    featureTooltip: "Attach files within a note.",
    core: "available",
    complete: "available",
    enterprise: "available",
    "ai-only": "available",
  },
  {
    feature: "ICD-10 Code Autocomplete",
    featureTooltip: "Easily add an ICD-10 code to any note.",
    core: "available",
    complete: "available",
    enterprise: "available",
    "ai-only": "available",
  },
  {
    feature: "Patient e-Signature",
    featureTooltip: "Document client signatures on any assessments or forms.",
    core: "available",
    complete: "available",
    enterprise: "available",
    "ai-only": "available",
  },
  {
    feature: "Labs & Prescriptions",
    featureTooltip: "Order e-labs and e-prescriptions.",
    core: "not-available",
    complete: "coming-soon",
    enterprise: "coming-soon",
    "ai-only": "not-available",
  },
];

export const BILLING_FEATURES: FeatureRows = [
  {
    feature: "Integrated Payment Processing via Stripe",
    featureTooltip:
      "Allow clients to pay bills online using a credit card, debit card, or  HSA/FSA card.",
    core: "available",
    complete: "available",
    enterprise: "available",
    "ai-only": "not-available",
  },
  {
    feature: "Secure & Guaranteed Payments",
    featureTooltip:
      "Take advantage of Orchid's unique payment system that reduces collections to $0.",
    core: "available",
    complete: "available",
    enterprise: "available",
    "ai-only": "not-available",
  },
  {
    feature: "Low Payment Processing Fees",
    featureTooltip:
      "Among the lowest variable fees in the industry. Flat fees of $.25 and $.30 per transaction may apply.",
    core: "available",
    complete: "available",
    enterprise: "available",
    "ai-only": "not-available",
  },
  {
    feature: "Auto-Generated Superbills",
    featureTooltip: "Automatically generate and send superbills.",
    core: "available",
    complete: "available",
    enterprise: "available",
    "ai-only": "not-available",
  },
  {
    feature: "Auto-Generated Invoices",
    featureTooltip: "Automatically generate and send invoices.",
    core: "available",
    complete: "available",
    enterprise: "available",
    "ai-only": "not-available",
  },
  {
    feature: "Insurance Processing",
    featureTooltip:
      "CMS-1500/HCFA forms, electronic insurance claims, payment reports, and more.",
    core: "coming-soon",
    complete: "coming-soon",
    enterprise: "coming-soon",
    "ai-only": "not-available",
  },
];

export const SUPPORT_FEATURES: FeatureRows = [
  {
    feature: "Comprehensive Resources",
    featureTooltip:
      "Learn on-demand from Orchid's extensive help guides & more.",
    core: "available",
    complete: "available",
    enterprise: "available",
    "ai-only": "not-available",
  },
  {
    feature: "24/7 Phone Support",
    featureTooltip: "",
    core: "not-available",
    complete: "available",
    enterprise: "available",
    "ai-only": "not-available",
  },
  {
    feature: "24/7 Live Chat Support",
    featureTooltip: "",
    core: "available",
    complete: "available",
    enterprise: "available",
    "ai-only": "not-available",
  },
  {
    feature: "24/7 Email Support",
    featureTooltip: "",
    core: "available",
    complete: "available",
    enterprise: "available",
    "ai-only": "not-available",
  },
  {
    feature: "Responses within 1 Hour",
    featureTooltip: "",
    core: "not-available",
    complete: "available",
    enterprise: "available",
    "ai-only": "not-available",
  },
];

export const COMMUNICATE_WITH_CLIENTS: FeatureRows = [
  {
    feature: "Intuitive Client Portal",
    featureTooltip:
      "Provide clients with an easy-to-use dashboard to fill out paperwork, make payments, send messages, schedule sessions, and more.",
    core: "available",
    complete: "available",
    enterprise: "available",
    "ai-only": "not-available",
  },
  {
    feature: "Customizable Intakes & Assessments",
    featureTooltip:
      "Send electronic intakes & assessments to clients with automated reminders.",
    core: "available",
    complete: "available",
    enterprise: "available",
    "ai-only": "available",
  },
  {
    feature: "Secure Client Messaging",
    featureTooltip:
      "Communicate in a HIPAA-compliant manner when messaging clients.",
    core: "available",
    complete: "available",
    enterprise: "available",
    "ai-only": "not-available",
  },
  {
    feature: "Automated Client Communications",
    featureTooltip:
      "Remind clients about assessments, set auto-replies, and more.",
    core: "available",
    complete: "available",
    enterprise: "available",
    "ai-only": "not-available",
  },
];

export const SECURITY_FEATURES: FeatureRows = [
  {
    feature: "100% HIPAA Compliance",
    featureTooltip: "",
    core: "available",
    complete: "available",
    enterprise: "available",
    "ai-only": "available",
  },
  {
    feature: "BAA Available",
    featureTooltip: "",
    core: "available",
    complete: "available",
    enterprise: "available",
    "ai-only": "available",
  },
  {
    feature: "End-to-End Encryption",
    featureTooltip: "",
    core: "available",
    complete: "available",
    enterprise: "available",
    "ai-only": "available",
  },
  {
    feature: "Regular Security Testing",
    featureTooltip: "",
    core: "available",
    complete: "available",
    enterprise: "available",
    "ai-only": "available",
  },
];

export const ACCOUNT_FEATURES: FeatureRows = [
  {
    feature: "Marketplace Directory Profile",
    featureTooltip:
      "Grow your practice by listing your availability to prospective clients.",
    core: "available",
    complete: "available",
    enterprise: "available",
    "ai-only": "not-available",
  },
  {
    feature: "Exclusive Professional Networking",
    featureTooltip: "Network with professionals in your community.",
    core: "not-available",
    complete: "available",
    enterprise: "available",
    "ai-only": "not-available",
  },
  {
    feature: "Unlimited Business Storage",
    featureTooltip:
      "Get your own unlimited business storage, from documents to large files.",
    core: "not-available",
    complete: "available",
    enterprise: "available",
    "ai-only": "not-available",
  },
  {
    feature: "Automated Business Analytics",
    featureTooltip:
      "Track income, outstanding balances, appointments, and more all under one dashboard.",
    core: "not-available",
    complete: "available",
    enterprise: "available",
    "ai-only": "not-available",
  },
  {
    feature: "CE Credits via Hosted Courses",
    featureTooltip: "Get invited to earn CE credits.",
    core: "not-available",
    complete: "available",
    enterprise: "available",
    "ai-only": "not-available",
  },
  {
    feature: "Early Access to the Latest Benefits",
    featureTooltip: "Enjoy access to early features that save you time & money",
    core: "not-available",
    complete: "available",
    enterprise: "available",
    "ai-only": "not-available",
  },
  {
    feature: "Client Mobile App",
    featureTooltip:
      "Ensure ease-of-use for your clients via Orchid's mobile app.",
    core: "coming-soon",
    complete: "coming-soon",
    enterprise: "coming-soon",
    "ai-only": "not-available",
  },
];
